import { render, staticRenderFns } from "./ResasStats.vue?vue&type=template&id=dd604262&scoped=true"
import script from "./ResasStats.vue?vue&type=script&lang=js"
export * from "./ResasStats.vue?vue&type=script&lang=js"
import style0 from "./ResasStats.vue?vue&type=style&index=0&id=dd604262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd604262",
  null
  
)

export default component.exports